import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedUserAction, clearUsersActions, getUsersActions } from '../../redux/actions/usersActions';

const useFetchUsers = () => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.users?.search);
  const users = useSelector((state) => state.users?.users);
  const loading = useSelector((state) => state.users?.loading);

  const fetchUsers = useCallback(async () => {
    await dispatch(getUsersActions(search));
  }, [search, dispatch]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  useEffect(() => {
    return () => {
      dispatch(clearUsersActions());
      dispatch(clearSelectedUserAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchUsers();
  };

  return { loading, users, refresh };
};

export default useFetchUsers;
